<input
  #fileInput
  type="file"
  hidden
  (change)="onFileSelected($event)"
  [attr.data-testid]="TiptapEditorTestIds.inputUploadfile" />

<button
  mat-icon-button
  type="button"
  aria-label="Datei hochladen"
  [attr.data-testid]="TiptapEditorTestIds.buttonUploadfile"
  (click)="openFileDialog($event)">
  <mat-icon svgIcon="upload"></mat-icon>
</button>
